import Vue from 'vue'
import router from 'vue-router'
// import Inicio from './components/inicio'
//import SobreMi from './components/sobreMi' (importacion normal)
//import Contacto from './components/contacto'
//import Post from './components/post'
import NotFound from './components/NotFound'
import AdmiSimple from './components/AdmiSimple'
import AdmiAvanzado from './components/AdmiAvanzado'
import DirecEquivocada from './components/DirecEquivocada'
import Administrador from './components/administrador'
//(impotacion con lazyloading)
const PortadaLL = () => import('./components/inicio')
const SobreMiLL = () => import('./components/sobreMi')
const PortafolioLL = () => import('./components/Portafolio')
const ServiciosLL = () => import('./components/Servicios')


Vue.use(router)
export default new router({
mode: 'history' ,
routes: [
{
path:'/' ,
component: PortadaLL,
name: 'inicio'
},
{
    path: '/home',
    redirect: '/'
},
{
    path: '/inicio',
    redirect: '/'
},
{
    path: '/portada',
    redirect: '/'
},

{
    path:'/sobreMi' ,
    component: SobreMiLL,
    name: 'sobreMiLL',
    alias: ['/acerca'],
},
{
    path: '/portafolio',
    component: PortafolioLL,
    alias: ['/Portafolio'],

},
{
    path: '/servicios',
    component: ServiciosLL,
    alias: ['/servicio']
},
{
    path: '/administrador',
    component: Administrador,
    children: [
        {
            path: 'simple',
            component: AdmiSimple,
        },
        {
            path: 'avanzado',
            component: AdmiAvanzado,
        }
    ]
},
{
    path: '/Administrador/*',
    component: DirecEquivocada
},
{
    path: '*' ,
    component: NotFound,
},

]
})

